import React, { useEffect, useState } from 'react';

import bgImage from '../../../main/assets/images/fpvAce/Noise Effect.webp';
import containerBgImageDesktop from '../../../main/assets/images/fpvAce/Boxes_content_bg.webp';
import containerBgImageMobile from '../../../main/assets/images/fpvAce/Boxes_content_vertical_bg.webp';
import boxFirstChapter from '../../../main/assets/images/fpvAce/fpv-controller.webp';
import boxSecondChapter from '../../../main/assets/images/fpvAce/drone-and-uberlite.webp';
import boxThirdChapter from '../../../main/assets/images/fpvAce/fpv-racing-goggles.webp';

const boxData = [
  {
    bgImage: bgImage,
    mainImage: boxFirstChapter,
    text:
      'Reliable FPV.Ctrl radio controller for simulator practice and for accurate drone control',
    alt: 'FPV.Ctrl Controller for Drones',
  },
  {
    bgImage: bgImage,
    mainImage: boxSecondChapter,
    text: 'Microdrone with Ghost UberLite radio module - best duo in the game',
    alt: 'Microdrone and Ghost UberLite Radio Module',
  },
  {
    bgImage: bgImage,
    mainImage: boxThirdChapter,
    text: 'High-end analog FPV goggles with ultra-low latency video feed',
    alt: 'Analog FPV Racing Goggles',
  },
];

export const BoxesContent = () => {
  const [containerBg, setContainerBg] = useState(containerBgImageDesktop);

  useEffect(() => {
    const updateBackground = () => {
      if (window.innerWidth <= 991) {
        setContainerBg(containerBgImageMobile);
      } else {
        setContainerBg(containerBgImageDesktop);
      }
    };

    updateBackground(); // Call it initially
    window.addEventListener('resize', updateBackground);

    return () => window.removeEventListener('resize', updateBackground);
  }, []);

  return (
    <div className="fpv-ace-boxes-container">
      <img
        src={containerBg}
        className="fpv-ace-boxes-bg"
        alt="Underlay Waves effect"
      />
      <div className="fpv-ace-boxes-header">
        <h2 className="fpv-ace-boxes-title">What’s in the boxes?</h2>
        <h3 className="fpv-ace-boxes-subtitle">
          FPV.Ace is all you need to learn how to fly, gradually improve your
          flying skills with the FPV.SkyDive simulator to skip crashing and
          start flying.
        </h3>
      </div>
      <div className="fpv-ace-boxes">
        {boxData.map((box, index) => (
          <div key={index} className="fpv-ace-box">
            <div
              className="fpv-ace-bg-image"
              style={{ backgroundImage: `url(${box.bgImage})` }}
            />
            <img
              src={box.mainImage}
              alt={box.alt}
              className="fpv-ace-main-image"
            />
            <p className="fpv-ace-text">{box.text}</p>
          </div>
        ))}
      </div>
    </div>
  );
};
